import { CoinRollsConfigurationContainer } from "@/model/data/cashFlow/CoinRollsConfiguration";
import { TransactionSubtypeEnum } from "@/model/data/enums/TransactionSubtypeEnum";

export class ApplicationStartupData {
    serverDateTime: Date;
    serverApplicationVersion: string;
    anyWindowsLoginAvailable: boolean;
    isSingleOrganizationInstallation: boolean;
    coinRollsConfiguration = new CoinRollsConfigurationContainer();
    azureADLoginEnabled: boolean = false;
    currentIp: string = "";
    forgotPasswordEnabled: boolean = false;
    brandedMode: boolean = false;
    blacklistedLanguages: string[];
    enabledTransactionsSubtypes: TransactionSubtypeEnum[];
    isWSFedAuthenticationEnabled: boolean = false;

    static parse(data: any): ApplicationStartupData {
        let res = new ApplicationStartupData();

        if (data.ServerDateTime) res.serverDateTime = new Date(data.ServerDateTime);
        if (data.AnyWindowsLoginAvailable) res.anyWindowsLoginAvailable = data.AnyWindowsLoginAvailable;
        if (data.IsSingleOrganizationInstallation) res.isSingleOrganizationInstallation = data.IsSingleOrganizationInstallation;
        if (data.ServerApplicationVersion) res.serverApplicationVersion = data.ServerApplicationVersion;
        if (data.CoinRollsConfiguration) res.coinRollsConfiguration = CoinRollsConfigurationContainer.parse(data.CoinRollsConfiguration);
        if (data.AzureADLoginEnabled != null) res.azureADLoginEnabled = data.AzureADLoginEnabled;
        if (data.ForgotPasswordEnabled != null) res.forgotPasswordEnabled = data.ForgotPasswordEnabled;
        if (data.CurrentIp && /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/.test(data.CurrentIp)) res.currentIp = data.CurrentIp;
        if (data.BrandedMode) res.brandedMode = data.BrandedMode;
        if (data.BlacklistedLanguages) res.blacklistedLanguages = data.BlacklistedLanguages;
        if (data.EnabledTransactionsSubtypes) {
            res.enabledTransactionsSubtypes = [];
            data.EnabledTransactionsSubtypes.forEach((subtype) => {
                res.enabledTransactionsSubtypes.push(subtype as TransactionSubtypeEnum);
            });
        }
        if (data.IsWSFedAuthenticationEnabled) res.isWSFedAuthenticationEnabled = data.IsWSFedAuthenticationEnabled;
        return res;
    }
}
